/* eslint-disable security/detect-object-injection */
import React from 'react';

function TypeDatePicker({changeHandler,dateError, date, month, year}) {
    const inputfocus = (elmnt) => {
        if (elmnt.key === 'Delete' || elmnt.key === 'Backspace') {
            if(elmnt.target.value.length!==0){
                return;
            }
            const next = elmnt.target.tabIndex - 2;
            if (next > -1) {
                elmnt.target.form.elements[next].focus();
            }
        } else {
            if(elmnt.target.id==="digit-1" || elmnt.target.id==="digit-2"){
                if(elmnt.target.value.length<2){
                    return;
                }
            }if(elmnt.target.id==="digit-3" && elmnt.target.value.length<4){
                return;
            }
            const next = elmnt.target.tabIndex;
            if (next < 3) {
                elmnt?.target?.form?.elements[next]?.focus();
            }
        }
    };
 
    return (
        <form className={`flex relative mt-[6px] py-[10px]  px-[12px] rounded h-[40px] border ${dateError!=='' ?  'border-[#B51803]' : 'border-[#797979]'}`}>
            <label htmlFor="digit-2" className="text-sm text-[#797979]">
                <input
                    type="text"
                    placeholder="MM"
                    autoComplete="off"
                    inputMode="decimal"
                    onKeyUp={inputfocus}
                    id="digit-2"
                    style={{ border: "none" }}
                    data-next="digit-1"
                    tabIndex="1"
                    className={`${month === '' ? 'w-[25px]' : 'w-[15px]'} text-[14px] bg-transparent outline-none text-[#333]`}
                    onChange={changeHandler}
                    value={month}
                    maxLength="2"
                />
            </label>
            <label htmlFor="digit-1" className="text-sm text-[#797979]">
                /<input
                    type="text"
                    placeholder="DD"
                    autoComplete="off"
                    inputMode="decimal"
                    onKeyUp={inputfocus}
                    style={{ border: "none" }}
                    name="digit-1"
                    id="digit-1"
                    data-next="digit-3"
                    data-previous="digit-2"
                    tabIndex="2"
                    onChange={changeHandler}
                    value={date}
                    maxLength="2"
                    className={`${date === '' ? 'w-[20px]' : 'w-[18px]'} text-[14px] bg-transparent outline-none text-[#333]`}
                />/
            </label>
            <label htmlFor="digit-3" className='text-sm pt-[3px] text-[#797979]'></label>
            <input
                type="text"
                placeholder="YYYY"
                autoComplete="off"
                inputMode="decimal"
                onKeyUp={inputfocus}
                id="digit-3"
                style={{ border: "none" }}
                data-previous="digit-1"
                tabIndex="3"
                className="w-20 text-[14px] bg-transparent outline-none pt-[3px] text-[#333]"
                onChange={changeHandler}
                value={year}
                maxLength="4"
            />
        </form>
    );
}

export default TypeDatePicker;